var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',_vm._g(_vm._b({attrs:{"type":"text","inputmode":"decimal","autocomplete":"off","value":_vm.display},on:{"keydown":_vm.onKeydown,"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus,"click":_vm.onClick}},'b-form-input',_vm.$attrs,false),_vm.forwardedListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }